import { Label } from "semantic-ui-react"
import Price from "components/Price/Price"
import React from "react"
import OrderModel   from "shop/OrderModel";
import shop from "shop/shop"

let orders = []
let ordersWithOpenPositions = []
let openPositions = []
let current = 0


const ProductPrice = ( { productCard, product, className = "pb4 pt2 relative lh-solid" } ) => {

  return <div className={`ProductPrice ${className}`} style={{ minWidth: productCard ? "100px" : "180px" , maxWidth: productCard ? "100px" : "180px" }}>
    <div className="flex flex-row pb2">
      
      {/*product.isSale && <Label className={"salePercent"} color="red">{product.salePercent}</Label>*/}

    </div>
    
    {product.pinfos && product.pinfos.gc_price_brutto && <div>
      {/*<div className="unit_multi black-70 f6 pb2 fw2">Stückpreis</div><br/>*/}
      <div className="f4 red fw7"> <span className="f5 black-60 fw7 pb1 strike "><Price>{product.pinfos.brutto}</Price></span><br/><Price>{product.pinfos && product.pinfos.gc_price_brutto ? product.pinfos.gc_price_brutto : product.price}</Price></div>
      <div className="pt1 black-30 f6 fw6 lh-solid">{product.extras.veextrainfo || translate( "Preis pro Stück" )}</div>
    </div>}
    
    {!product.pinfos && !product.pinfos.gc_price_brutto &&
    <div className="price  lh-solid  ">
      <div className="f4 fw7 "><Price>{product.price}</Price> {product.salePercent &&
      <span className={"black-60 f5 fw4"}>(<Price>{product.originalPrice}</Price> abzgl. {product.salePercent} Rabatt)</span>}
      </div>
      <div className="pt1 black-30 f6 fw6 lh-solid">{product.extras.veextrainfo || translate( "Preis pro Stück" )}</div>
    </div>}

    {product.pinfos && !product.pinfos.gc_price_brutto &&
    <div className="price  lh-solid  ">
      <div className="f4 fw7 "><Price>{product.price}</Price> {product.salePercent &&
      <span className={"black-60 f5 fw4"}>(<Price>{product.originalPrice}</Price> abzgl. {product.salePercent} Rabatt)</span>}
      </div>
      <div className="pt1 black-30 f6 fw6 lh-solid">{product.extras.veextrainfo || translate( "Preis pro Stück" )}</div>
    </div>}
    
  </div>
}

export default ProductPrice


// WEBPACK FOOTER //
// ./src/theme/lucht-test/components/Product/ProductPrice.js